// 玩家行走精灵表帧映射（部分素材左右行画反时在配置里标记 flipLR）
import { RESOURCE_CONFIG } from './ResourceConfig.js';

const STANDARD_RANGES = {
    down: { start: 0, end: 3 },
    up: { start: 12, end: 15 },
    left: { start: 4, end: 7 },
    right: { start: 8, end: 11 }
};

const STANDARD_STATIC = {
    down: 0,
    up: 12,
    left: 4,
    right: 8
};

export function isPlayerSpriteLRFlipped(element) {
    const player = RESOURCE_CONFIG.players.find((p) => p.key === element);
    return player?.flipLR === true;
}

export function getPlayerFrameRange(element, direction) {
    if (isPlayerSpriteLRFlipped(element)) {
        if (direction === 'left') return STANDARD_RANGES.right;
        if (direction === 'right') return STANDARD_RANGES.left;
    }
    return STANDARD_RANGES[direction];
}

export function getPlayerStaticFrame(element, direction) {
    if (isPlayerSpriteLRFlipped(element)) {
        if (direction === 'left') return STANDARD_STATIC.right;
        if (direction === 'right') return STANDARD_STATIC.left;
    }
    return STANDARD_STATIC[direction] ?? 0;
}

export function getPlayerAnimKey(element, direction) {
    return `${element}_${direction}`;
}

export function ensurePlayerAnimations(scene, element) {
    if (!scene?.anims || !scene.textures.exists(element)) return;

    for (const direction of ['down', 'up', 'left', 'right']) {
        const key = getPlayerAnimKey(element, direction);
        if (scene.anims.exists(key)) continue;

        const range = getPlayerFrameRange(element, direction);
        if (!range) continue;

        scene.anims.create({
            key,
            frames: scene.anims.generateFrameNumbers(element, range),
            frameRate: 10,
            repeat: -1
        });
    }
}
